import axios from "axios";
import { FormDateField, FormTimeField } from "../../components/form/date";
import {
  FormDropDown,
  FormMultiSelectDropDown,
} from "../../components/form/dropdown";
import { FormFileUploadField } from "../../components/form/file";
import { FormImageField } from "../../components/form/image";
import { FormMultiFileUploadField } from "../../components/form/multi-file";
import { FormMultiImageField } from "../../components/form/multi-image";
import FormTextField from "../../components/form/text";
import { FormTextAreaField } from "../../components/form/text-area";
import { url } from "../../config";
import MainLayout from "../../layout";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import { uiTypes } from "../../utils/types";
import { validatorTypes } from "../../utils/validatorTypes";
import { FormDropDownDynamic } from "../../components/form/dynamic-dropdown";
import { useEffect, useState } from "react";
import {
  FormCheckboxField,
  FormToggleSwitch,
} from "../../components/form/checkbox";
import FormJsonEditor from "../../components/form/json";
import { formatUnderscoreToSpace } from "../../utils/text-format";
import successToast from "../../components/toast/successToast";
import errorToast from "../../components/toast/errorToast";
import FormTextArrayField from "../../components/form/text-array";
import { FormMultiImageVideoField } from "../../components/form/multi-image-video";
import DynamicArrayJson from "../../components/form/dynamic-array-json-form";
import backArrow from "../../assets/icons/back-arrow.svg";
import { FormDocumentField } from "../../components/form/document-upload";
import { FormVideoField } from "../../components/form/video-field";
import { FormDocumentAltField } from "../../components/form/document-alt-upload";
import FormRichTextEditor from "../../components/form/form-editor";
import CountryCityLocalityInput from "../../components/form/country-city-locality-input";

const Editpage = ({ model }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const viewId = id;
  const { tableName, columns, read, edit, create, references } = model;
  const [viewData, setViewData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [initialValues, setInitialValues] = useState({});

  const columnHeadings = () => {
    var array = [];
    for (var i = 0; i < columns.length; i++) {
      var column = columns[i];
      if (column.ui?.edit == null || column.ui.edit == true) {
        array.push(column.name);
      }
    }
    return array;
  };
  const headings = columnHeadings();

  useEffect(() => {
    if (viewId) {
      axios
        .post(`${url}/model/${tableName}/read`, { id: viewId ?? "" })
        .then((response) => {
          var resData = { ...response.data.data };

          if (references != null) {
            for (let index = 0; index < references.length; index++) {
              const reference = references[index];
              if (Array.isArray(resData[reference.tableName])) {
                var arrayValues = [];
                for (let j = 0; j < resData[reference.tableName].length; j++) {
                  const element = resData[reference.tableName][j];
                  arrayValues.push(element[reference.displayKey]);
                }
                resData[reference.tableName] = arrayValues.toString();
              } else if (
                resData[references.tableName] &&
                typeof resData[references.tableName] === "object"
              ) {
                if (
                  resData[references.tableName][reference.displayKey] != null
                ) {
                  resData[reference.tableName] =
                    resData[references.tableName][reference.displayKey];
                } else {
                  resData[reference.tableName] = "";
                }
              } else {
                resData[reference.tableName] = "";
              }
            }
          }
          console.log("resData", resData);

          var values = columns.reduce((data, column) => {
            if (column.ui?.edit == null || column.ui.edit === true) {
              data[column?.name] = column?.name ? resData[column?.name] : "";
            }
            return data;
          }, {});

          setInitialValues({ ...values });

          setViewData(resData);
          setLoading(false);
        })
        .catch((error) => {
          console.error("API Error:", error);
          setLoading(false);
        });
    }
  }, [tableName, viewId]);

  const getValidationType = (validations = []) => {
    let schema = Yup.mixed();

    if (validations.includes(validatorTypes.string)) schema = Yup.string();
    else if (validations.includes(validatorTypes.email))
      schema = Yup.string().email("Invalid email");
    else if (validations.includes(validatorTypes.uuid))
      schema = Yup.string().uuid("Invalid UUID");
    else if (validations.includes(validatorTypes.number)) schema = Yup.number();
    else if (validations.includes(validatorTypes.bool)) schema = Yup.boolean();
    else if (validations.includes(validatorTypes.date)) schema = Yup.date();
    else if (validations.includes(validatorTypes.array)) schema = Yup.array();
    else if (validations.includes(validatorTypes.url))
      schema = Yup.string().url("Invalid URL");
    else if (validations.includes(validatorTypes.json)) schema = Yup.mixed();

    if (validations.includes(validatorTypes.required)) {
      schema = schema.required("This field is required");
    } else {
      schema = schema.notRequired();
    }

    return schema;
  };
  const validationSchema = Yup.object(
    columns.reduce((schema, column) => {
      if (column.ui?.create !== false) {
        const validations = column.ui?.validation?.length
          ? column.ui.validation
          : column.validation;
        schema[column.name] = getValidationType(validations);
      }
      return schema;
    }, {}),
  );

  const handleSubmit = (values) => {
    console.log("Submitted values:", values);
    axios
      .post(`${url}/model/${tableName}/edit`, {
        where: {
          id: id,
        },
        values: {
          ...values,
        },
      })
      .then((response) => {
        successToast(response.message);
        console.log(response, "response");
        navigate(`/${tableName}/list`);
      })
      .catch((error) => {
        console.error("API Error:", error);
        errorToast(error?.response?.data?.message);
      });
  };

  const enumToOptions = (enumValues = []) =>
    enumValues.map((val) => ({
      label: val.charAt(0).toUpperCase() + val.slice(1),
      value: val,
    }));

  return (
    <MainLayout>
      <section className="h-full overflow-auto px-3">
        {loading ? (
          "loading"
        ) : (
          <>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize={true}
            >
              {({ values }) => (
                <Form>
                  <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
                    <div className="flex items-center gap-2">
                      <button onClick={() => navigate(-1)} type="button">
                        <img src={backArrow} alt="<" width={10} height={10} />
                      </button>
                      <h2 className="text-xl font-semibold capitalize">
                        {formatUnderscoreToSpace(tableName)} - Edit
                      </h2>
                    </div>
                    <div className="flex gap-3 items-center">
                      <button
                        onClick={() => navigate(-1)}
                        type="button"
                        className="px-4 py-1 border-[2px] border-errorColor text-errorColor rounded"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
                      >
                        Save
                      </button>
                    </div>
                  </div>
                  <section className="w-full max-w-[40rem]">
                    {headings.map((heading) => {
                      const column = columns.find(
                        (value) => value.name === heading,
                      );

                      if (column?.ui?.display === false) {
                        return null;
                      }

                      if (
                        (column.ui?.edit === null ||
                          column?.ui?.edit === true) &&
                        column?.ui?.type === uiTypes?.CHECKBOX
                      ) {
                        return (
                          <div className="my-5">
                            <FormCheckboxField name={heading} label={heading} />
                          </div>
                        );
                      }

                      if (
                        (column.ui?.edit === null ||
                          column?.ui?.edit === true) &&
                        column?.ui?.type === uiTypes?.NUMBER
                      ) {
                        return (
                          <div className="my-5">
                            <FormTextField
                              name={heading}
                              label={heading}
                              placeholder={`Enter ${heading}`}
                              type="number"
                            />
                          </div>
                        );
                      }
                      if (
                        (column.ui?.create === null ||
                          column?.ui?.create === true) &&
                        column?.ui?.type === uiTypes?.TEXT_ARRAY
                      ) {
                        return (
                          <div className="my-5">
                            <FormTextArrayField
                              name={heading}
                              label={heading}
                            />
                          </div>
                        );
                      }

                      if (
                        column?.ui?.edit &&
                        column?.ui?.type === uiTypes?.TIME
                      ) {
                        return (
                          <div className="my-5">
                            <FormTimeField name={heading} label={heading} />
                          </div>
                        );
                      }
                      if (
                        column?.ui?.edit &&
                        column?.ui?.type === uiTypes?.DATE
                      ) {
                        return (
                          <div className="my-5">
                            <FormDateField name={heading} label={heading} />
                          </div>
                        );
                      }
                      if (
                        column?.ui?.edit &&
                        column?.ui?.type === uiTypes?.DATE_TIME
                      ) {
                        return (
                          <div className="my-5">
                            <FormDateField
                              name={heading}
                              label={heading}
                              type="datetime-local"
                            />
                          </div>
                        );
                      }

                      if (
                        column?.ui?.edit &&
                        column?.ui?.type === uiTypes?.TEXT_AREA
                      ) {
                        return (
                          <div className="my-5">
                            <FormTextAreaField
                              name={heading}
                              label={heading}
                              placeholder={`Enter ${heading}`}
                            />
                          </div>
                        );
                      }

                      if (
                        column?.ui?.edit &&
                        column?.ui?.type === uiTypes?.DROPDOWN
                      ) {
                        if (!column?.enumValues) {
                          var reference = references.find(
                            (value) => value.foreignKey == heading,
                          );
                          return (
                            <div className="my-5">
                              <FormDropDownDynamic
                                name={heading}
                                label={heading}
                                reference={reference}
                                placeholder="Select"
                              />
                            </div>
                          );
                        }

                        return (
                          <div className="my-5">
                            <FormDropDown
                              name={heading}
                              label={heading}
                              options={enumToOptions(column?.enumValues)}
                              value={enumToOptions(column?.enumValues)?.find(
                                (item) => item?.value === values?.[heading],
                              )}
                            />
                          </div>
                        );
                      }
                      if (
                        column?.ui?.edit &&
                        column?.ui?.type === uiTypes?.DROPDOWN_MULTISELECT
                      ) {
                        return (
                          <div className="my-5">
                            <FormMultiSelectDropDown
                              name={heading}
                              label={heading}
                              options={enumToOptions(column?.enumValues)}
                              value={enumToOptions(column?.enumValues)?.find(
                                (item) => item?.value === values?.[heading],
                              )}
                            />
                          </div>
                        );
                      }

                      if (
                        column?.ui?.edit &&
                        column?.ui?.type === uiTypes.IMAGE
                      ) {
                        return (
                          <div className="my-5">
                            <FormImageField name={heading} label={heading} />
                          </div>
                        );
                      }

                      if (
                        (column.ui?.create === null ||
                          column?.ui?.create === true) &&
                        column?.ui?.type === uiTypes.DOCUMENT
                      ) {
                        return (
                          <div className="my-5">
                            <FormDocumentField name={heading} label={heading} />
                          </div>
                        );
                      }

                      if (
                        (column.ui?.create === null ||
                          column?.ui?.create === true) &&
                        column?.ui?.type === uiTypes.DOCUMENT_ALT
                      ) {
                        return (
                          <div className="my-5">
                            <FormDocumentAltField
                              name={heading}
                              label={heading}
                            />
                          </div>
                        );
                      }
                      if (
                        (column.ui?.create === null ||
                          column?.ui?.create === true) &&
                        column?.ui?.type === uiTypes.VIDEO
                      ) {
                        return (
                          <div className="my-5">
                            <FormVideoField name={heading} label={heading} />
                          </div>
                        );
                      }

                      if (
                        column?.ui?.edit &&
                        column?.isArray &&
                        column?.ui?.type === uiTypes.MULTI_IMAGE
                      ) {
                        return (
                          <div className="my-5">
                            <FormMultiImageField
                              name={heading}
                              label={heading}
                            />
                          </div>
                        );
                      }
                      if (
                        (column.ui?.create === null ||
                          column?.ui?.create === true) &&
                        column?.isArray &&
                        column?.ui?.type === uiTypes.MULTI_IMAGE_VIDEO
                      ) {
                        return (
                          <div className="my-5">
                            <FormMultiImageVideoField
                              name={heading}
                              label={heading}
                            />
                          </div>
                        );
                      }

                      if (
                        column?.ui?.edit &&
                        column?.ui?.type === uiTypes.FILE
                      ) {
                        return (
                          <div className="my-5">
                            <FormFileUploadField
                              name={heading}
                              label={heading}
                              accept=".pdf,.doc,.docx"
                            />
                          </div>
                        );
                      }
                      if (
                        column?.ui?.edit &&
                        column?.isArray &&
                        column?.ui?.type === uiTypes.MULTI_FILE
                      ) {
                        return (
                          <div className="my-5">
                            <FormMultiFileUploadField
                              name={heading}
                              label={heading}
                              accept=".pdf,.doc,.docx,.jpg,.png"
                            />
                          </div>
                        );
                      }
                      if (
                        (column.ui?.edit === null ||
                          column?.ui?.edit === true) &&
                        column?.ui?.type === uiTypes?.JSON
                      ) {
                        return (
                          <div className="my-5">
                            <FormJsonEditor
                              name={heading}
                              label={heading}
                              value={values?.[heading]}
                            />
                          </div>
                        );
                      }
                      if (
                        (column.ui?.edit === null ||
                          column?.ui?.edit === true) &&
                        column?.ui?.type === uiTypes?.SWITCH
                      ) {
                        return (
                          <div className="my-5">
                            <FormToggleSwitch
                              name={heading}
                              label={heading}
                              value={values?.[heading]}
                            />
                          </div>
                        );
                      }

                      if (
                        (column.ui?.create === null ||
                          column?.ui?.create === true) &&
                        column?.ui?.type === uiTypes?.DYNAMICJSON
                      ) {
                        return (
                          <div className="my-5">
                            <DynamicArrayJson
                              name={heading}
                              label={heading}
                              value={values?.[heading]}
                              dynamicArrayfeilds={
                                column?.ui?.dynamicArrayfeilds
                              }
                            />
                          </div>
                        );
                      }

                      if (
                        (column.ui?.create === null ||
                          column?.ui?.create === true) &&
                        column?.ui?.type === uiTypes?.EDITOR
                      ) {
                        return (
                          <FormRichTextEditor name={heading} label={heading} />
                        );
                      }

                      if (
                        (column.ui?.create === null ||
                          column?.ui?.create === true) &&
                        column?.ui?.type === uiTypes?.COUNTRY_CITY_LOCALITY
                      ) {
                        return (
                          <div className="my-5">
                            <CountryCityLocalityInput
                              name={heading}
                              label={heading}
                            />
                          </div>
                        );
                      }

                      return (
                        <>
                          {column?.ui?.edit && (
                            <div className="my-5">
                              <FormTextField
                                label={heading}
                                name={heading}
                                placeholder={`Enter ${heading}`}
                              />
                            </div>
                          )}
                        </>
                      );
                    })}
                  </section>
                </Form>
              )}
            </Formik>
          </>
        )}
      </section>
    </MainLayout>
  );
};

export default Editpage;
